"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybePluralize = void 0;
const maybePluralize = (count, noun, suffix = 's') => `${count} ${noun}${count !== 1 ? suffix : ''}`;
exports.maybePluralize = maybePluralize;
